var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting_content" }, [
    _c("div", { staticClass: "setting_content_main" }, [
      _c("form", { on: { change: _vm.logChangeData } }, [
        _c("div", { staticClass: "setting_content_heading" }, [
          _c("h2", { staticClass: "setting_content_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.labelProperties.HEAD_TITLE) +
                "\n        "
            )
          ])
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.labelProperties.HEADING_SETTING) +
                "\n        "
            )
          ]),
          _c("p", { staticClass: "setting_unit_explain" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.labelProperties.SUB_HEADING_SETTING) +
                "\n        "
            )
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.labelProperties.LABEL_HEADING_SETTING) +
                  "\n          "
              )
            ]),
            _c(
              "div",
              { staticClass: "setting_unit_form" },
              [
                _c(
                  "draggable",
                  {
                    attrs: {
                      list: _vm.headingSettings,
                      group: {
                        name: "item-job",
                        put: _vm.canDragDropHeading && _vm.isCanDragToHeading
                      },
                      draggable: ".item"
                    },
                    on: {
                      add: function($event) {
                        return _vm.addItemToHeadingBodySetting(1)
                      }
                    }
                  },
                  [
                    _vm._l(_vm.headingSettings, function(
                      headingSetting,
                      index
                    ) {
                      return _c(
                        "div",
                        { key: index, staticClass: "item" },
                        [
                          headingSetting && !headingSetting.itemResourceDeleted
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "setting_form_wrapper",
                                    on: {
                                      mousedown: function($event) {
                                        _vm.isCanDragToBody = false
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "setting_options_category_item",
                                        class: headingSetting.isItemDeletedByMainSystem
                                          ? "item-deleted-setting"
                                          : ""
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "setting_options_category_item_icon",
                                            attrs: {
                                              width: "10",
                                              height: "12",
                                              xmlns:
                                                "http://www.w3.org/2000/svg"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  fill: "#aaa",
                                                  "fill-rule": "evenodd"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                headingSetting.display_name,
                                              expression:
                                                "headingSetting.display_name"
                                            }
                                          ],
                                          staticClass:
                                            "setting_form_text customize_setting_text",
                                          attrs: {
                                            type: "text",
                                            placeholder:
                                              _vm.labelProperties.PLACE_HOLDER,
                                            readonly: "",
                                            title: headingSetting.isItemDeletedByMainSystem
                                              ? _vm.labelProperties
                                                  .MESSAGE_ITEM_DELETE
                                              : ""
                                          },
                                          domProps: {
                                            value: headingSetting.display_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                headingSetting,
                                                "display_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    headingSetting.display_name && index > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "setting_form_wrapper_delete",
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteItemHeadingSetting(
                                                  _vm.headingSettings,
                                                  index,
                                                  false,
                                                  "heading"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "12",
                                                  height: "12",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      fill: "#AAA",
                                                      "fill-rule": "evenodd"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M.255 1.545l.99-.99 9.9 9.9-.99.99z"
                                                      }
                                                    }),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M10.155.555l.99.99-9.9 9.9-.99-.99z"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "setting_form_wrapper_close",
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteItemHeadingSetting(
                                              _vm.headingSettings,
                                              index,
                                              true,
                                              "heading"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "12",
                                              height: "12",
                                              xmlns:
                                                "http://www.w3.org/2000/svg"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  fill: "none",
                                                  "fill-rule": "evenodd"
                                                }
                                              },
                                              [
                                                _c("rect", {
                                                  attrs: {
                                                    fill: "#555",
                                                    width: "12",
                                                    height: "12",
                                                    rx: "2"
                                                  }
                                                }),
                                                _c(
                                                  "g",
                                                  { attrs: { fill: "#FFF" } },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                                      }
                                                    }),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.canDragDropHeading,
                            expression: "canDragDropHeading"
                          }
                        ],
                        staticClass: "setting_form_wrapper mt-1",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c("input", {
                          staticClass: "setting_form_text",
                          attrs: {
                            type: "text",
                            placeholder: _vm.labelProperties.PLACE_HOLDER,
                            readonly: ""
                          }
                        }),
                        _vm.checkSettingsLength(_vm.headingSettings) !== 0
                          ? _c(
                              "div",
                              {
                                staticClass: "setting_form_wrapper_delete",
                                on: {
                                  click: function($event) {
                                    _vm.canDragDropHeading = false
                                  }
                                }
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "12",
                                      height: "12",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          fill: "#AAA",
                                          "fill-rule": "evenodd"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M.255 1.545l.99-.99 9.9 9.9-.99.99z"
                                          }
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M10.155.555l.99.99-9.9 9.9-.99-.99z"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  2
                ),
                _vm.checkSettingsLength(_vm.headingSettings) <
                _vm.configProperties.MAX_ITEM
                  ? _c("div", { staticClass: "setting_unit_add" }, [
                      _c(
                        "a",
                        {
                          staticClass: "setting_unit_add_btn",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              _vm.canDragDropHeading = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.labelProperties.ADD_ITEM) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.labelProperties.BODY_SETTING) +
                "\n        "
            )
          ]),
          _c("p", { staticClass: "setting_unit_explain" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.labelProperties.SUB_BODY_SETTING) +
                "\n        "
            )
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.labelProperties.LABEL_BODY_SETTING) +
                  "\n          "
              )
            ]),
            _c(
              "div",
              { staticClass: "setting_unit_form" },
              [
                _c(
                  "draggable",
                  {
                    attrs: {
                      list: _vm.bodySettings,
                      group: {
                        name: "item-job",
                        put: _vm.canDragDropBody && _vm.isCanDragToBody
                      },
                      draggable: ".item"
                    },
                    on: {
                      add: function($event) {
                        return _vm.addItemToHeadingBodySetting(2)
                      }
                    }
                  },
                  [
                    _vm._l(_vm.bodySettings, function(bodySetting, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "item" },
                        [
                          bodySetting && !bodySetting.itemResourceDeleted
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "setting_form_wrapper",
                                    on: {
                                      mousedown: function($event) {
                                        _vm.isCanDragToHeading = false
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "setting_options_category_item",
                                        class: bodySetting.isItemDeletedByMainSystem
                                          ? "item-deleted-setting"
                                          : ""
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "setting_options_category_item_icon",
                                            attrs: {
                                              width: "10",
                                              height: "12",
                                              xmlns:
                                                "http://www.w3.org/2000/svg"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  fill: "#aaa",
                                                  "fill-rule": "evenodd"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: bodySetting.display_name,
                                              expression:
                                                "bodySetting.display_name"
                                            }
                                          ],
                                          staticClass:
                                            "setting_form_text customize_setting_text",
                                          attrs: {
                                            type: "text",
                                            placeholder:
                                              _vm.labelProperties.PLACE_HOLDER,
                                            readonly: "",
                                            title: bodySetting.isItemDeletedByMainSystem
                                              ? _vm.labelProperties
                                                  .MESSAGE_ITEM_DELETE
                                              : ""
                                          },
                                          domProps: {
                                            value: bodySetting.display_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                bodySetting,
                                                "display_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    bodySetting.display_name && index > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "setting_form_wrapper_delete",
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteItemHeadingSetting(
                                                  _vm.bodySettings,
                                                  index,
                                                  false,
                                                  "body"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "12",
                                                  height: "12",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      fill: "#AAA",
                                                      "fill-rule": "evenodd"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M.255 1.545l.99-.99 9.9 9.9-.99.99z"
                                                      }
                                                    }),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M10.155.555l.99.99-9.9 9.9-.99-.99z"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "setting_form_wrapper_close",
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteItemHeadingSetting(
                                              _vm.bodySettings,
                                              index,
                                              true,
                                              "body"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "12",
                                              height: "12",
                                              xmlns:
                                                "http://www.w3.org/2000/svg"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  fill: "none",
                                                  "fill-rule": "evenodd"
                                                }
                                              },
                                              [
                                                _c("rect", {
                                                  attrs: {
                                                    fill: "#555",
                                                    width: "12",
                                                    height: "12",
                                                    rx: "2"
                                                  }
                                                }),
                                                _c(
                                                  "g",
                                                  { attrs: { fill: "#FFF" } },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                                      }
                                                    }),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.canDragDropBody,
                            expression: "canDragDropBody"
                          }
                        ],
                        staticClass: "setting_form_wrapper mt-1",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c("input", {
                          staticClass: "setting_form_text",
                          attrs: {
                            type: "text",
                            placeholder: _vm.labelProperties.PLACE_HOLDER,
                            readonly: ""
                          }
                        }),
                        _vm.checkSettingsLength(_vm.bodySettings) !== 0
                          ? _c(
                              "div",
                              {
                                staticClass: "setting_form_wrapper_delete",
                                on: {
                                  click: function($event) {
                                    _vm.canDragDropBody = false
                                  }
                                }
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "12",
                                      height: "12",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          fill: "#AAA",
                                          "fill-rule": "evenodd"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M.255 1.545l.99-.99 9.9 9.9-.99.99z"
                                          }
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M10.155.555l.99.99-9.9 9.9-.99-.99z"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  2
                ),
                _vm.checkSettingsLength(_vm.bodySettings) <
                _vm.configProperties.MAX_ITEM
                  ? _c("div", { staticClass: "setting_unit_add" }, [
                      _c(
                        "a",
                        {
                          staticClass: "setting_unit_add_btn",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              _vm.canDragDropBody = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.labelProperties.ADD_ITEM) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _c(
      "div",
      [
        _c("DragDropComponent", {
          attrs: {
            groupName: _vm.groupName,
            jobCategories: _vm.jobCategories,
            property: _vm.property,
            resourceFields: _vm.resourceFields,
            useType: _vm.useType,
            idSetScroll: _vm.idSetScroll,
            isDispatch: true
          },
          on: {
            updatedProperty: _vm.updatedProperty,
            refreshResourceList: _vm.refreshResourceList,
            getJobResourceFields: _vm.getJobResourceFields,
            updateCanDragDrop: _vm.updateCanDragDrop
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }